import {
  // issue list fetch type:
  ISSUE_LIST_FETCH_PROCESSING,
  ISSUE_LIST_FETCH_SUCCESS,
  ISSUE_LIST_FETCH_FAILED,
  ISSUE_LIST_FETCH_CLEAR,

  // issue fetch type:
  ISSUE_FETCH_PROCESSING,
  ISSUE_FETCH_SUCCESS,
  ISSUE_FETCH_FAILED,
  ISSUE_FETCH_CLEAR,

  // issue update type:
  ISSUE_UPDATE_SUCCESS,
  ISSUE_UPDATE_FAILED,
} from '../constants';
import { issue, observer } from '../data';

/* ===============================================
 *  IssueListReducer action consist type of
 *  - ISSUE_LIST_*
 * =============================================== */

// setStateIssueListFetchToProcessing()
const setStateIssueListFetchToProcessing = () => ({
  type: ISSUE_LIST_FETCH_PROCESSING,
});

/**
 * setStateIssueListFetchToToSuccess()
 * @param {*} payload
 */
const setStateIssueListFetchToToSuccess = (payload) => ({
  type: ISSUE_LIST_FETCH_SUCCESS,
  payload,
});

/**
 * setStateIssueListFetchToToFailed()
 */
const setStateIssueListFetchToToFailed = () => ({
  type: ISSUE_LIST_FETCH_FAILED,
});

/**
 * setStateIssueListFetchToToClear()
 */
const setStateIssueListFetchToToClear = () => ({
  type: ISSUE_LIST_FETCH_CLEAR,
});

/**
 * getList()
 * @param {object} params
 * @param {object} params.package base64 of props {...}
 * @returns issue list
 */
export const getList = (params) => {
  return async (dispatch, getState) => {
    dispatch(setStateIssueListFetchToProcessing());
    try {
      let data = await issue.getList(params);
      dispatch(setStateIssueListFetchToToSuccess(data));
    } catch (error) {
      dispatch(setStateIssueListFetchToToFailed());
      throw error;
    }
  };
};

/**
 * clearList()
 * @returns issue list
 */
 export const clearList = (params) => {
  return async (dispatch) => {
      await dispatch(setStateIssueListFetchToToClear());
  };
};

/* ===============================================
 *  IssueReducer action consist type of
 *  - ISSUE_FETCH
 *  - ISSUE_UPDATE
 * =============================================== */

// [ISSUE_FETCH]

// setStateIssueFetchToProcessing()
const setStateIssueFetchToProcessing = () => ({
  type: ISSUE_FETCH_PROCESSING,
});

/**
 * setStateIssueFetchToToSuccess()
 * @param {*} payload
 */
const setStateIssueFetchToSuccess = (payload) => ({
  type: ISSUE_FETCH_SUCCESS,
  payload,
});

/**
 * setStateIssueFetchToToFailed()
 */
const setStateIssueFetchToFailed = () => ({
  type: ISSUE_FETCH_FAILED,
});

/**
 * setStateIssueFetchToToClear()
 */
const setStateIssueFetchToClear = () => ({
  type: ISSUE_FETCH_CLEAR,
});

/**
 * getIssueDetail
 * @param {object} params
 * @param {object} params.package base64 of props {lang; 'TH', id: 'issue guid'}
 * @param {object} options {includedThumbnail, includedViewStatus }
 */
export const getIssueDetail = (params, options) => {
  return async (dispatch) => {
    dispatch(setStateIssueFetchToProcessing());
    try {
      let data = await issue.getDetail(params, options);
      dispatch(setStateIssueFetchToSuccess(data));
    } catch (error) {
      dispatch(setStateIssueFetchToFailed(error.message));
      throw error;
    }
  };
};

// [ISSUE_UPDATE]
const setStateIssueUpdateToSuccess = (payload) => ({
  type: ISSUE_UPDATE_SUCCESS,
  payload: payload,
});

const setStateIssueUpdateToFailed = () => ({
  type: ISSUE_UPDATE_FAILED,
});

/**
 * updateIssue()
 * @param {object} props,
 * @param {object} props.data, issue data object
 * @param {string} props.logMode, issue mode (issueEdit | issueCreate)
 * @param {object} props.params, params: {package} base64 of props {lang; 'TH', id: 'issue guid'}
 * @param {object} props.options {includedThumbnail, includedViewStatus }
 */

export const updateIssue = ({ data = {}, params, options }) => {
  return async (dispatch) => {
    try {
      await issue.updateIssue({ issue: data, logMode: 'issueEdit' });

      let issueUpdated = await issue.getDetail(params, options);

      dispatch(setStateIssueUpdateToSuccess(issueUpdated));
    } catch (error) {
      dispatch(setStateIssueUpdateToFailed(error.message));
      throw error;
    }
  };
};

/**
 * forwardIssue()
 * @param {object} props.data, forward-issue data object { issue_id, category_id, level, permissionGroupFilter = null}
 * @param {object} props.params, params: {package} base64 of props {lang; 'TH', id: 'issue guid'}
 * @param {object} props.options {includedThumbnail, includedViewStatus }
 * @returns
 */
export const forwardIssue = ({ data, params, options }) => {
  let { issue_id, category_id, level, permissionGroupFilter } = data;
  return async (dispatch) => {
    try {
      await issue.forwardIssue({
        issue_id,
        category_id,
        level,
        permissionGroupFilter,
      });

      let issueUpdated = await issue.getDetail(params, options);

      dispatch(setStateIssueUpdateToSuccess(issueUpdated));
    } catch (error) {
      dispatch(setStateIssueUpdateToFailed(error.message));
      throw error;
    }
  };
};

/**
 * updateIssueLabel()
 * @param {object} props,
 * @param {object} props.id, issue id
 * @param {array} props.labels, labels
 * @param {object} props.params, params: {package}  base64 of props {lang; 'TH', id: 'issue guid'}
 * @param {object} props.options {includedThumbnail, includedViewStatus }
 */
export const updateIssueLabel = ({ id, labels, params, options }) => {
  return async (dispatch) => {
    try {
      await issue.updateIssue({
        issue: {
          id,
        },
        labels,
        logMode: 'issueLabelSet',
      });

      let issueUpdated = await issue.getDetail(params, options);

      dispatch(setStateIssueUpdateToSuccess(issueUpdated));
    } catch (error) {
      dispatch(setStateIssueUpdateToFailed(error.message));
      throw error;
    }
  };
};

/**
 * updateIssueDimension()
 * @param {object} props,
 * @param {object} props.id, issue id
 * @param {array} props.dimensions, dimensions
 * @param {object} props.params, params: {package}  base64 of props {lang; 'TH', id: 'issue guid'}
 * @param {object} props.options {includedThumbnail, includedViewStatus }
 */
export const updateIssueDimension = ({ id, dimensions, params, options }) => {
  return async (dispatch) => {
    try {
      await issue.updateIssue({
        issue: {
          id,
        },
        dimensions,
        logMode: 'issueDimensionSet',
      });

      let issueUpdated = await issue.getDetail(params, options);

      dispatch(setStateIssueUpdateToSuccess(issueUpdated));
    } catch (error) {
      dispatch(setStateIssueUpdateToFailed(error.message));
      throw error;
    }
  };
};

/**
 * updateProcessStatus()
 * @param {object} props,
 * @param {object} props.data, issue data object
 * @param {string} props.logMode, issue mode (issueEdit | issueCreate)
 * @param {object} props.params, {package}
 * @param {string} props.params.package base64 of props {lang; 'TH', id: 'issue guid'}
 * @param {object} props.options {includedThumbnail, includedViewStatus }
 */
export const updateProcessStatus = ({
  issue_id,
  status_id,
  params,
  options,
}) => {
  return async (dispatch) => {
    try {
      await issue.updateProcessStatus({ issue_id, status_id });

      let issueUpdated = await issue.getDetail(params, options);

      dispatch(setStateIssueUpdateToSuccess(issueUpdated));
    } catch (error) {
      dispatch(setStateIssueUpdateToFailed(error.message));
      throw error;
    }
  };
};

/**
 * addObserver()
 * @param {object} props,
 * @param {object} props.issue_id, issue id
 * @param {string} props.user_id, user id
 * @param {object} props.params, {package}
 * @param {string} props.params.package base64 of props {lang; 'TH', id: 'issue guid'}
 * @param {object} props.options {includedThumbnail, includedViewStatus }
 */
 export const addObserver = ({
  issue_id,
  user_id,
  params,
  options
}) => {
  return async (dispatch) => {
    try {
      await observer.addObserver({ issue_id, user_id });

      let issueUpdated = await issue.getDetail(params, options);

      dispatch(setStateIssueUpdateToSuccess(issueUpdated));
    } catch (error) {
      dispatch(setStateIssueUpdateToFailed(error.message));
      throw error;
    }
  };
};

/**
 * removeObserver()
 * @param {object} props,
 * @param {object} props.issue_id, issue id
 * @param {string} props.user_id, user id
 * @param {object} props.params, {package}
 * @param {string} props.params.package base64 of props {lang; 'TH', id: 'issue guid'}
 * @param {object} props.options {includedThumbnail, includedViewStatus }
 */
 export const removeObserver = ({
  issue_id,
  user_id,
  params,
  options
}) => {
  return async (dispatch) => {
    try {
      await observer.removeObserver({ issue_id, user_id });

      let issueUpdated = await issue.getDetail(params, options);

      dispatch(setStateIssueUpdateToSuccess(issueUpdated));
    } catch (error) {
      dispatch(setStateIssueUpdateToFailed(error.message));
      throw error;
    }
  };
};


/**
 * setVote()
 * @param {object} props,
 * @param {object} props.issue_id, issue data object
 * @param {string} props.vote, vote value 0 | 1
 * @param {object} params, {package}
 * @param {string} params.package base64 of props {lang; 'TH', id: 'issue guid'}
 */
 export const setVote = ({
  issue_id,
  vote,
  params,
}) => {
  return async (dispatch) => {
    try {
      await issue.setVote({ issue_id, vote });

      let issueUpdated = await issue.getDetail(params);

      dispatch(setStateIssueUpdateToSuccess(issueUpdated));
    } catch (error) {
      dispatch(setStateIssueUpdateToFailed(error.message));
      throw error;
    }
  };
};
